import type { JourneyRadarItem } from './journey-radar';
import {
  matchesWorkRadarStage,
  matchesWorkRadarView,
  type WorkRadarView
} from './work-radar';

export function filterWorkRadarItems(
  items: JourneyRadarItem[],
  filters: {
    projectId: string;
    query: string;
    stageKey: string;
    view: WorkRadarView;
  }
) {
  const normalizedQuery = filters.query.trim().toLowerCase();
  return items.filter((item) => {
    if (
      filters.projectId !== 'all' &&
      !item.journey.projectIds.includes(filters.projectId)
    )
      return false;
    if (
      !matchesWorkRadarView(filters.view, {
        attentionLevel: item.attentionLevel,
        hasFailedSignal: item.hasFailedSignal,
        isStale: item.isStale,
        waitingOnHuman: item.nextAction?.waitingOn === 'human',
        hasLinkGap: item.hasLinkGap
      })
    )
      return false;
    if (!matchesWorkRadarStage(filters.stageKey, item.stages)) return false;
    return !normalizedQuery || item.searchText.includes(normalizedQuery);
  });
}
